module.exports = __webpack_public_path__ + "assets/img/image04.7ce59ee1.png";